import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Flex, Layout } from 'antd';
import { GoogleOutlined, WindowsOutlined } from '@ant-design/icons';
import * as Sentry from '@sentry/react';
import { routePaths } from 'router';
import { saveTokens } from 'services/auth';
import { firebaseAuth } from 'services/firebase/firebase-auth.ts';
import { useAuthMutation } from 'api/auth/use-auth.ts';
import type { UserRes } from 'api/swagger';
import { useAuthStore } from 'shared/stores';
import styles from './auth.module.scss';

export const Auth: React.FC = () => {
  const navigate = useNavigate();
  const { setAuth } = useAuthStore();
  const { mutate: authMutation } = useAuthMutation({
    handleSuccess: (data) => {
      Sentry.setUser({ id: data.user?.id, email: data.user?.email });
      saveTokens(data);
      setAuth(data.user as UserRes);
      navigate(routePaths.cargos);
    },
  });

  const sendToken = (token: string) => authMutation({ type: 'crm', token });

  const handleMicrosoftLogin = async () => {
    const token = await firebaseAuth.microsoftAuth();
    if (token) {
      sendToken(token);
    }
  };

  const handleGoogleLogin = async () => {
    const token = await firebaseAuth.googleAuth();
    if (token) {
      sendToken(token);
    }
  };

  return (
    <Layout className={styles.red}>
      <h1>{import.meta.env.VITE_COMPANY_TITLE}</h1>
      <Flex gap='middle' vertical>
        <Button icon={<WindowsOutlined />} onClick={handleMicrosoftLogin}>
          Microsoft
        </Button>
        <Button icon={<GoogleOutlined />} onClick={handleGoogleLogin}>
          Google
        </Button>
      </Flex>
    </Layout>
  );
};
